import React, { useState } from "react";

function ConfirmPopup(props) {
  const [inputValue, setInputValue] = useState("");

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleConfirm = () => {
    if (inputValue === props.confirmValue) {
      props.onConfirm();
    }
  };

  const handleCancel = () => {
    props.onCancel();
  };

  return (
    <div style={{ alignSelf: "center", marginTop: 15 }}>
      <div>{props.message}</div>
      <input
        type="text"
        style={{ marginTop: 10 }}
        value={inputValue}
        onChange={handleInputChange}
      />
      <button
        style={{
          backgroundColor: "red",
          color: "white",
          border: "0px",
          marginLeft: 10,
        }}
        onClick={handleConfirm}
      >
        Confirm
      </button>
      <button
        style={{
          backgroundColor: "gray",
          color: "white",
          border: "0px",
          marginLeft: 10,
        }}
        onClick={handleCancel}
      >
        Cancel
      </button>
    </div>
  );
}

export default ConfirmPopup;
